import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import lockIcon from 'icons/lock.svg';
import { fontBold } from 'themes';

export const StyledMediaCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: ${({ theme }) => theme.edgeDistance};
  ${({ border, theme }) => {
    if (border) {
      return `
        border-bottom: 1px solid ${theme.borderColor};
        border-top: 1px solid ${theme.borderColor};
      `;
    }
  }}
`;

const MainContent = styled.div`
  flex: 1;
  ${({ hasLeftItem }) => (hasLeftItem ? 'margin-left: 15px;' : '')}
  overflow: hidden;
  text-align: left;
`;

export const Title = styled.div`
  color: black;
  font-family: ${fontBold};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Subtitle = styled.div`
  color: #939c9e;
  font-size: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const LockIcon = styled.img.attrs({ src: lockIcon })`
  margin: 0px 10px;
`;

const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
`;

const MediaCard = ({
  border,
  leftItem,
  title,
  subtitle,
  subItem,
  rightItem,
  isPrivate = false,
  ...props
}) => (
  <StyledMediaCard border={border} {...props}>
    {leftItem && <div>{leftItem}</div>}
    <MainContent hasLeftItem={!!leftItem}>
      <TitleRow>
        <Title>{title}</Title>
        {isPrivate && <LockIcon />}
      </TitleRow>
      <Subtitle>{subtitle}</Subtitle>
      {subItem}
    </MainContent>
    {rightItem && <div>{rightItem}</div>}
  </StyledMediaCard>
);

MediaCard.propTypes = {
  border: PropTypes.bool,
  leftItem: PropTypes.oneOfType([PropTypes.bool, PropTypes.element]),
  rightItem: PropTypes.element,
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  title: PropTypes.node
};

export default MediaCard;
